// components/PageBreadcrumb.jsx

import { Link } from "react-router-dom";

const PageBreadcrumb = ({ items }) => {
  return (
    <nav className="flex items-center flex-wrap gap-2 text-sm pt-2">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          {index > 0 && <span className="txtred"> / </span>}

          {index === items.length - 1 || !item.link ? (
            <span className="font-semibold txtred">
              {item.label}
            </span>
          ) : (
            <Link
              to={item.link}
              className="text-red-600 hover:text-red-600"
            >
              {item.label}
            </Link>
          )}
        </span>
      ))}
    </nav>
  );
};

export default PageBreadcrumb;